module.exports = __webpack_public_path__ + "static/media/DanskeHuman-MediumItalic.5e1461a5.svg";